import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, GitBranch, Building2, FileText, Megaphone, Settings, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import logo from '@/assets/aksaaf-logo.jpg';

const NAV = [
    { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { to: '/pipeline', label: 'Pipeline', icon: GitBranch },
    { to: '/developers', label: 'Developers & Projects', icon: Building2 },
    { to: '/contracts', label: 'Contracts & Documents', icon: FileText },
    { to: '/marketing', label: 'Marketing & Ads', icon: Megaphone },
];

export default function Sidebar({ open, onClose }) {
    const { profile } = useAuth();
    const isAdmin = profile?.role === 'admin';
    return (
        <>
            {open && (<div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={onClose} aria-hidden />)}
            <aside className={`aks-sidebar-scroll fixed lg:static z-50 inset-y-0 left-0 w-64 bg-aks-navy text-white flex flex-col transform transition-transform duration-200 ease-out ${open ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`} data-testid="sidebar">
                <div className="px-5 pt-5 pb-4 flex items-center justify-between">
                    <div className="flex items-center gap-2.5">
                        <div className="h-9 w-9 rounded-md bg-white flex items-center justify-center overflow-hidden flex-shrink-0">
                            <img src={logo} alt="AKSAAF" className="h-8 w-8 object-contain" />
                        </div>
                        <div>
                            <div className="font-bold tracking-tight text-[14px] text-white leading-none">AKSAAF Properties</div>
                            <div className="text-[9px] uppercase tracking-[0.16em] text-white/55 mt-0.5">CRM</div>
                        </div>
                    </div>
                    <button onClick={onClose} className="lg:hidden text-white/70 hover:text-white" aria-label="Close sidebar"><X className="h-5 w-5" /></button>
                </div>
                <nav className="flex-1 overflow-y-auto px-3 py-2 space-y-0.5">
                    {NAV.map((item) => {
                        const Icon = item.icon;
                        return (
                            <NavLink key={item.to} to={item.to} onClick={onClose} className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-[14px] transition-colors ${isActive ? 'bg-[rgba(201,168,76,0.16)] text-white border-l-2 border-aks-gold' : 'text-white/80 hover:bg-white/5 hover:text-white'}`} data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-').replace('&','and')}`}>
                                <Icon className="h-[18px] w-[18px]" />
                                <span>{item.label}</span>
                            </NavLink>
                        );
                    })}
                    {isAdmin && (
                        <NavLink to="/settings" onClick={onClose} className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-[14px] transition-colors ${isActive ? 'bg-[rgba(201,168,76,0.16)] text-white border-l-2 border-aks-gold' : 'text-white/80 hover:bg-white/5 hover:text-white'}`} data-testid="nav-settings">
                            <Settings className="h-[18px] w-[18px]" />
                            <span>Settings</span>
                        </NavLink>
                    )}
                </nav>
                <div className="px-5 py-4 border-t border-white/10">
                    <div className="text-[11px] text-white/45">AKSAAF Properties</div>
                    <div className="text-[10px] text-white/30 mt-0.5">v2.0 · B2B + Contracts + Marketing</div>
                </div>
            </aside>
        </>
    );
}
